import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        const modal = this.el.querySelector('[data-open-modal = "modal"]');
        const openModal = this.el.querySelector('[data-open-modal = "open-modal"]');
        const modalClose = this.el.querySelector('[data-open-modal = "close-modal"]');
        openModal.addEventListener('click', () => {
            modal.classList.add('open-modal');
        });
        modalClose.addEventListener('click', function () {
             modal.classList.remove('open-modal');
        });
    }
}
